export default "__VITE_ASSET__CpHoWCeK__"